import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  readonly show = signal(false);
  readonly message = signal('');
  readonly typeClass = signal('toast-info');

  showToast(message: string, type: string = 'success', duration: number = 3000): void {
    this.message.set(message);
    this.typeClass.set(`toast-${type}`);
    this.show.set(true);
    this.rolarAteOTopo();

    setTimeout(() => {
      this.hideToast();
    }, duration);
  }

  hideToast(): void {
    this.show.set(false);
  }

  /**
   * O aviso fica fixo no topo da página, e rolar até lá garante que ele seja
   * visto. Dentro do portal a aplicação roda num iframe sem rolagem própria
   * (ver `@iframe-resizer/child` em `app.component.ts`): ali o `position: fixed`
   * prende o toast ao topo do documento do iframe, não ao da janela, então quem
   * precisa rolar é a página que o contém — daí `scrollToOffset`. O
   * `window.scrollTo` cobre o caso sem `parentIFrame`, como o dev local.
   */
  private rolarAteOTopo(): void {
    if (window.parentIFrame) {
      window.parentIFrame.scrollToOffset(0, 0);
      return;
    }

    window.scrollTo({ top: 0 });
  }
}
